"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Result, _PureComponent);

  function Result(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Result.prototype;

  _proto.handleNodeClick = function handleNodeClick(id) {
    var _this$props$datum$get = this.props.datum.getPath(id),
        path = _this$props$datum$get.path;

    this.props.onPathChange(id, null, path);
  };

  _proto.renderClear = function renderClear() {
    var _this$props = this.props,
        clearable = _this$props.clearable,
        value = _this$props.value,
        disabled = _this$props.disabled,
        onClear = _this$props.onClear;
    var className = (0, _classnames.default)((0, _styles.selectClass)('indicator', 'close'), (0, _styles.cascaderClass)('close'));

    if (clearable && value.length > 0 && !disabled) {
      /* eslint-disable */
      return _react.default.createElement("a", {
        tabIndex: -1,
        className: className,
        href: "javascript:;",
        onClick: onClear
      });
      /* eslint-enable */
    }

    return null;
  };

  _proto.renderPlaceholder = function renderPlaceholder() {
    return _react.default.createElement("span", {
      className: (0, _classnames.default)((0, _styles.inputClass)('placeholder'), (0, _styles.selectClass)('ellipsis'))
    }, this.props.placeholder, "\xA0");
  };

  _proto.renderResult = function renderResult() {
    var _this2 = this;

    var _this$props2 = this.props,
        datum = _this$props2.datum,
        value = _this$props2.value,
        renderItem = _this$props2.renderItem,
        renderResult = _this$props2.renderResult,
        compressed = _this$props2.compressed;
    var nodes = value.map(function (v) {
      return datum.getDataById(v);
    });
    var render = renderResult || renderItem;

    if (typeof render === 'string') {
      var copyRender = render;

      render = function render(n) {
        return n[copyRender];
      };
    }

    var neededResult = compressed ? nodes.slice(0, 1) : nodes;
    var items = neededResult.map(function (n, i) {
      var res = n && render(n);
      if (!res) return null;
      return _react.default.createElement("a", {
        tabIndex: -1,
        className: (0, _styles.cascaderClass)('item'),
        onClick: _this2.handleNodeClick.bind(_this2, value[i]),
        key: i
      }, res);
    });

    if (compressed && nodes.length > 1) {
      items.push(_react.default.createElement("a", {
        tabIndex: -1,
        key: items.length,
        className: (0, _styles.cascaderClass)('item', 'item-compressed')
      }, _react.default.createElement("span", null, "+" + (nodes.length - 1))));
    }

    return items;
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        style = _this$props3.style,
        value = _this$props3.value;
    var result = value.length === 0 ? this.renderPlaceholder() : this.renderResult();
    return _react.default.createElement("div", {
      className: (0, _styles.cascaderClass)('result'),
      style: style
    }, result, !this.props.multiple && // eslint-disable-next-line
    _react.default.createElement("a", {
      tabIndex: -1,
      className: (0, _styles.selectClass)('indicator', 'caret'),
      href: "javascript:;"
    }), this.renderClear());
  };

  return Result;
}(_react.PureComponent);

Result.propTypes = {
  clearable: _propTypes.default.bool,
  datum: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  onClear: _propTypes.default.func,
  onPathChange: _propTypes.default.func,
  placeholder: _propTypes.default.any,
  renderItem: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  renderResult: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  style: _propTypes.default.object,
  value: _propTypes.default.array,
  compressed: _propTypes.default.bool
};
Result.defaultProps = {
  value: []
};
var _default = Result;
exports.default = _default;